export const theme = {
  colors: {
    black: '#0d0d0f',
    white: '#fff',

    gray100: '#E1E1E6',
    gray200: '#D4D4D8',
    gray300: '#C4C4CC',
    gray400: '#8D8D99',
    gray500: '#7C7C8A',
    gray600: '#323238',
    gray700: '#29292E',
    gray800: '#202024',
    gray900: '#121214',
    lightGrey: '#ededed',
    grey: '#dadada',
    darkGrey: '#3f3f46',

    accent: '#818cf8',
    accentDark: '#6366f1',
    cyan: '#38bdf8',
    accentGradient: 'linear-gradient(135deg, #818cf8 0%, #38bdf8 100%)',

    yellow: '#ffda78',
    yellow500: '#FBA94C',
    purple: '#818cf8',

    green300: '#4ade80',
    green500: '#22c55e',
    green700: '#15803d',
    green: '#f4fcf8',

    red300: '#F75A68',
    red500: '#AB222E',
    red700: '#7A1921',
    red: '#d0312d',
  },
  fontWeight: {
    thin: 100,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
};
